export default "__VITE_ASSET__BszBwd52__"